var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle123(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "5.740715823522343 370.3098300700731 16.016945358965472 15.47802341902701",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.27,374.32c.54.21,1.54.46,2.39.97,1.17.7,1.45,2.4.62,3.47-.62.8-1.35,1.54-2.13,2.19-1.65,1.4-3.71,1-4.82-.86-.84-1.4-.76-2.78.1-4.13.78-1.23,1.98-1.66,3.84-1.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle123);
export default __webpack_public_path__ + "static/media/twinkle-1-23.d34c4fe12f4bafe448bf1a9c470bb2f2.svg";
export { ForwardRef as ReactComponent };